import 'swiper/css'

import { Box, Grid, GridProps, Stack } from '@chakra-ui/react'
import { ProductFormulaCard } from 'components/sections/ProductFormulaSection/components/ProductFormulaCard'
import { H2, H5 } from 'components/typography'
import { FC, ReactNode } from 'react'
import { Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { menPowerIngredients } from 'utils/data/ingredients/menPowerIngredients'

export interface ProductFormulaSectionItem {
  title?: string
  subtitle?: string
  description?: string
  imgSrc?: string
  img?: ReactNode
}

interface ProductFormulaSectionProps {
  title?: string
  description?: string
  items?: ProductFormulaSectionItem[]
  contentContainerProps?: GridProps
}

const ProductFormulaSection: FC<ProductFormulaSectionProps> = ({
  title = 'A fórmula',
  items = menPowerIngredients,
  description = 'O +lib é uma fórmula exclusiva Omens\u00AE, com 8 ingredientes cuidadosamente selecionados pelos nossos médicos, em um processo rigoroso guiado pela ciência.',
  contentContainerProps
}) => {
  return (
    <Stack bg="alabaster" p={{ base: 6, lg: 24 }} spacing={{ base: 8, lg: 16 }}>
      <Stack direction={{ base: 'column', lg: 'row' }} spacing={{ base: 2, lg: 16 }}>
        {title && (
          <H2
            size="3xl"
            mb={4}
            fontWeight="800"
            minW="fit-content"
            flex={0.3}
            textAlign={{
              base: 'left',
              lg: 'center'
            }}
          >
            {title}
          </H2>
        )}
        {!!description && <H5 flex={1}>{description}</H5>}
      </Stack>

      <Grid
        display={{ base: 'none', lg: 'grid' }}
        gap={8}
        templateColumns={{
          base: '1fr',
          lg: `repeat(${Math.floor(items.length / 2)}, 1fr)`
        }}
        {...contentContainerProps}
      >
        {items.map((item) => {
          return <ProductFormulaCard key={item.title} {...item} />
        })}
      </Grid>

      <Box
        display={{
          base: 'block',
          lg: 'none'
        }}
      >
        <Swiper
          grabCursor={true}
          slidesPerView={1.33}
          modules={[Pagination, Navigation]}
          spaceBetween={20}
          breakpoints={{
            630: {
              slidesPerView: 3.66,
              slidesOffsetBefore: 30,
              pagination: false
            },
            1440: {
              slidesPerView: 4.66,
              slidesOffsetBefore: 30,
              pagination: false
            }
          }}
        >
          {items.map((item) => {
            return (
              <SwiperSlide key={item.title}>
                <ProductFormulaCard {...item} />
              </SwiperSlide>
            )
          })}
        </Swiper>
      </Box>
    </Stack>
  )
}

export default ProductFormulaSection
